import { useBoloPanelMetadata } from '../../../state/bolo-panel-metadata-context';
import { BoloLogTabContent } from './bolo-log-tab-content';
import { observer } from 'mobx-react-lite';

export const BoloLogTab = observer(() => {
    const metadata = useBoloPanelMetadata();

    if (!metadata) {
        return null;
    }

    return <BoloLogTabContent boloId={metadata.boloId} />;
});
